module.exports = __webpack_public_path__ + "img/generated-1772420675191.19b358c7.png";